import * as React from "react";
import { IconProps } from "./IconProps";

export const IconClose = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g clipPath="url(#clip0_5307_238759)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.08038 1.07647C1.62676 0.530094 2.5126 0.530094 3.05898 1.07647L14.9305 12.948C15.4769 13.4944 15.4769 14.3803 14.9305 14.9266C14.3842 15.473 13.4983 15.473 12.9519 14.9266L1.08038 3.05506C0.53401 2.50869 0.53401 1.62284 1.08038 1.07647Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.9269 1.07647C15.4733 1.62284 15.4733 2.50869 14.9269 3.05506L3.05537 14.9266C2.50899 15.473 1.62315 15.473 1.07677 14.9266C0.530399 14.3803 0.530399 13.4944 1.07677 12.948L12.9483 1.07647C13.4947 0.530094 14.3806 0.530094 14.9269 1.07647Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_5307_238759">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
